<template>
  <div id="footer-div">
    <footer
      class="footer footer-auto fixed-bottom"
      :class="{ 'footer-hidden': isHidden }"
      style="background-color: #e4ff26; color: black"
    >
      <div
        class="container d-flex flex-column flex-md-row align-items-center justify-content-between py-3"
      >
        <!-- Left -->
        <div class="mb-2 mb-md-0">© 2026 Copyright</div>

        <!-- Center -->
        <div class="mb-2 mb-md-0">
          <a href="https://www.ptspace.pt" target="_blank">
            <img
              src="../assets/logo_black.png"
              alt="PT Space"
              height="50"
              style="object-fit: contain"
            />
          </a>
        </div>

        <!-- Right -->
        <div>
          <a
            href="https://ptspace.pt/privacy-policy/"
            target="_blank"
            class="footer-link"
            >Privacy Policy</a
          >
        </div>
      </div>
    </footer>
  </div>
  <!-- End of .container -->
</template>
<style>
.footer-link {
  color: black;
  text-decoration: none;
  font-size: 1rem;
}

.footer-link:hover {
  text-decoration: none;
  color: #757d83;
}
.footer {
  backdrop-filter: blur(6px);
}

.footer-auto {
  transform: translateY(0);
  transition: transform 0.25s ease;
  will-change: transform;
}

.footer-hidden {
  transform: translateY(100%);
}

@media (prefers-reduced-motion: reduce) {
  .footer-auto {
    transition: none;
  }
}
</style>
<script>
import { useRoute } from "vue-router";
export default {
  setup() {
    const route = useRoute();
    const routeName = route.path.slice(1);
    return {
      routeName,
    };
  },
  data() {
    return {
      isHidden: false,
      lastY: 0,
    };
  },
  computed: {
    scrollEffectsDisabled() {
      return ["/home", "/main"].includes(
        String(this.$route.path || "").toLowerCase(),
      );
    },
  },
  watch: {
    "$route.path"() {
      this.isHidden = false;
      this.lastY = window.pageYOffset || 0;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.lastY = window.pageYOffset || 0;
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (this.scrollEffectsDisabled) {
        this.isHidden = false;
        this.lastY = y;
        return;
      }

      if (y < 80) {
        this.isHidden = false;
        this.lastY = y;
        return;
      }

      if (y - this.lastY > 10) {
        this.isHidden = true;
      } else if (this.lastY - y > 10) {
        this.isHidden = false;
      }

      this.lastY = y;
    },
  },
};
</script>
